export default __webpack_public_path__ + "assets/images/c6ebc159ce38ef9991d10e57f9c243b5.png";